import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

import { Col, Row } from 'react-bootstrap'
import MyImage from '@shared/components/myImage'
import CustomLink from '@shared/components/customLink'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import TeamImage from '@assets/images/placeholder/playerPagePlaceholder.svg'
import { calculateAge } from '@shared-submodule/utils'

function PlayerCards({ teamsList }) {
  return (
    <Row>
      {teamsList?.map((team, i) => {
        return (
          <Col id={team?.sFullName} key={team?.sFullName + '_' + i} sm={12} md={4} className='px-2'>
            {team?.oSeo?.sSlug && team?.eTagStatus === 'a' ? <CustomLink href={`/${team.oSeo.sSlug}`} prefetch={false}>
              <a className={`${styles.team} common-box d-flex`}>
                <div className={`${styles.playerLogo} mx-auto flex-shrink-0`}>
                  <MyImage
                    src={team?.oImg?.sUrl ? `${S3_PREFIX}${team?.oImg?.sUrl}` : TeamImage}
                    alt={team?.sAbbr || 'Team Logo'}
                    placeholderImage={TeamImage}
                    width={40}
                    height={40}
                    layout="responsive"
                  />
                </div>
                <div className="flex-grow-1 align-items-center">
                  <h6 className={`${styles.name} font-bold`}>{team?.sFullName}</h6>
                  <div className={`${styles.middleContent} d-flex`}>
                    {
                      team?.oTeam?.oImg?.sUrl && (
                        <div className={`${styles.teamLogo}`}>
                          <MyImage
                            src={team?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${team?.oTeam?.oImg?.sUrl}` : TeamImage}
                            alt={team?.sAbbr}
                            placeholderImage={TeamImage}
                            width={40}
                            height={40}
                            layout="responsive"
                          />
                        </div>
                      )
                    }
                    {
                      team?.sCountryFull && (
                        <span className={`${styles.caption} ${team?.dBirthDate && styles.dotSymbol} font-bold`}>{team?.sCountryFull}</span>
                      )
                    }
                    {
                      team?.dBirthDate && <span className={`${styles.caption} font-bold`}>{`${calculateAge(team.dBirthDate)} Years`}</span>
                    }
                  </div>
                  {
                    team?.aRanking?.length > 0 && (
                      <div>
                        {
                          team?.aRanking?.slice(0, 3).map((ele, index) => (
                            // <span key={`${ele?.eMatchType}_${index}`} className={`${ele?.eMatchType === 'ODI' ? styles.odiRank : ele?.eMatchType === 'Test' ? styles.testRank : styles.T20IRank}`}>{`${ele?.eMatchType} Rank ${ele?.nRank}`}</span>
                            <span key={` ${ele?.eMatchType}_${index}`} className={`${ele?.eMatchType === 'ODI' ? styles.odiRank : ele?.eMatchType === 'Test' ? styles.testRank : styles.T20IRank} ${index === 0 && styles.firstRank}`}>{`${ele?.eMatchType} Rank ${ele?.nRank}`}</span>
                          ))
                        }
                      </div>
                    )
                  }
                </div>
              </a>
            </CustomLink> : <div className={`${styles.team} ${team?.eTagStatus !== 'a' && 'shadow-none'} common-box d-flex`}>
              <div className={`${styles.playerLogo}`}>
                <MyImage
                  src={team?.oImg?.sUrl ? `${S3_PREFIX}${team?.oImg?.sUrl}` : TeamImage}
                  alt={team?.sAbbr}
                  placeholderImage={TeamImage}
                  width={40}
                  height={40}
                  layout="responsive"
                />
              </div>
              <div className="flex-grow-1 align-items-center">
                <h6 className={`${styles.name} font-bold`}>{team?.sFullName}</h6>
                <div className={`${styles.middleContent} d-flex`}>
                  {
                    team?.oTeam?.oImg?.sUrl && (
                      <div className={`${styles.teamLogo}`}>
                        <MyImage
                          src={team?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${team?.oTeam?.oImg?.sUrl}` : TeamImage}
                          alt={team?.sAbbr}
                          placeholderImage={TeamImage}
                          width={40}
                          height={40}
                          layout="responsive"
                        />
                      </div>
                    )
                  }
                  {
                    team?.sCountryFull && (
                      <span className={`${styles.caption} ${team?.dBirthDate && styles.dotSymbol} font-bold`}>{team?.sCountryFull}</span>
                    )
                  }
                  {
                    team?.dBirthDate && <span className={`${styles.caption} font-bold`}>{`${calculateAge(team.dBirthDate)} Years`}</span>
                  }
                </div>
                {
                  team?.aRanking?.length > 0 && (
                    <div className='mt-1'>
                      {
                        team?.aRanking?.map((ele, index) => (
                          <span key={`${styles.rank} ${ele?.eMatchType}_${index}`} className={`${ele?.eMatchType === 'ODI' ? styles.odiRank : ele?.eMatchType === 'Test' ? styles.testRank : styles.T20IRank}`}>{`${ele?.eMatchType} Rank ${ele?.nRank}`}</span>
                        ))
                      }
                    </div>
                  )
                }
              </div>
            </div>}
          </Col>)
      })}
    </Row>
  )
}

PlayerCards.propTypes = {
  teamsList: PropTypes.array
}

export default PlayerCards
